import {
    PRODUCT_IMPORT_ADD_SKU,
    PRODUCT_IMPORT_BATCH_DONE,
    PRODUCT_IMPORT_CHUNK_COMPLETED,
    PRODUCT_IMPORT_IN_PROGRESS,
    PRODUCT_IMPORT_QUEUE_FETCHING,
    PRODUCT_IMPORT_QUEUE_FETCHING_FAILURE,
    PRODUCT_IMPORT_QUEUE_FETCHING_SUCCESS,
    PRODUCT_IMPORT_REMOVE_SKU,
} from '../actions/types'

/**
 * @typedef {Object} ProductImportData
 * @property {string} id
 * @property {string} sku
 * @property {string|null} ean
 * @property {string|null} grossWeight
 * @property {string|null} netWeight
 * @property {number|null} depth
 * @property {number|null} height
 * @property {number|null} width
 * @property {string} name
 * @property {boolean} isBundle
 * @property {string|null} description
 * @property {'NEW'|'IN_PROGRESS'|'COMPLETED'|'FAILED'} state
 * @property {string|null} model
 * @property {number|null} hurtonCategory
 * @property {number|null} eltroxCategory
 * @property {string|null} warranty
 * @property {string|null} warrantyForCompanies
 * @property {string|null} productManager
 * @property {Object[]} attributes
 * @property {string} createdAt
 * @property {string} updatedAt
 * @property {Object[]} prices
 */

/**
 * @typedef {Object.<string, ProductImportData>} ProductImportDataMap
 */

/**
 * @prop {ProductImportDataMap} items
 * @prop {boolean} loading
 */
const INITIAL_STATE = {
    items: {},
    loading: false,
    page: 1,
    pageSize: 10,
    total: 0,
    pages: 100000,
    importInProgress: false,
    importTotalChunks: 0,
    importProcessedChunks: 0,
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // case PRODUCT_IMPORT_ADD_SKU:
        //     return {
        //         ...state,
        //         items: {
        //             ...state.items,
        //             [action.sku]: {
        //                 state: 'added',
        //             },
        //         },
        //     }
        //
        // case PRODUCT_IMPORT_REMOVE_SKU:
        //     const { [action.sku]: removed, ...rest } = state.items
        //     return { ...state, items: rest }
        //
        case PRODUCT_IMPORT_IN_PROGRESS:
            return {
                ...state,
                importInProgress: true,
                importTotalChunks: action.totalChunks,
                importProcessedChunks: 0,
            }

        case PRODUCT_IMPORT_CHUNK_COMPLETED:
            return {
                ...state,
                importProcessedChunks: state.importProcessedChunks + 1,
            }

        case PRODUCT_IMPORT_BATCH_DONE:
            return {
                ...state,
                importInProgress: false,
            }

        case PRODUCT_IMPORT_QUEUE_FETCHING:
            return {
                ...state,
                loading: Object.keys(state.items).length === 0,
            }

        case PRODUCT_IMPORT_QUEUE_FETCHING_SUCCESS:
            return {
                ...state,
                loading: false,
                items: prepareItems(action.payload.items),
                page: action.payload.page,
                pageSize: action.payload.pageSize,
                total: action.payload.total,
                pages: action.payload.pages,
            }

        case PRODUCT_IMPORT_QUEUE_FETCHING_FAILURE:
            return {
                ...state,
                loading: false,
            }

        default:
            return state
    }
}

/**
 * @param {ProductImportData[]} items
 */
const prepareItems = items => {
    let result = items.reduce((acc, item) => {
        acc[item.id] = item
        return acc
    }, {})

    return result
}

export default reducer
